import * as types from '../constants/ActionTypes'
import api from '../utils/api'

let getCannedMessages = (companyId, agentId) => {
	return (dispatch, getState) => {
		let currentAgent = getState().app.currentAgent.userInfo

		if (currentAgent.companyId !== companyId || currentAgent._id !== agentId)
			return

		dispatch(getCannedCompanyMessagesInitiated())

		api('/' + companyId + '/cannedMessages')
			.get()
			.then(cannedMessages => dispatch(getCannedCompanyMessagesFinished(cannedMessages)))
			.then(
				() => {
					dispatch(getCannedAgentMessagesInitiated())
					api('/' + companyId + '/cannedMessagesByAgent/' + agentId)
						.get()
						.then(cannedMessages => dispatch(getCannedAgentMessagesFinished(cannedMessages)))
						.catch(err => dispatch(getCannedAgentMessagesFailure()))
				}
			)
			.catch(err => dispatch(getCannedCompanyMessagesFailure()))
	}
}

let getCannedCompanyMessagesInitiated = () => {
	return {
		type: types.GET_COMPANY_CANNED_MESSAGES,
		payload: {}
	}
}

let getCannedCompanyMessagesFinished = (cannedMessages) => {
	return {
		type: types.GET_COMPANY_CANNED_MESSAGES_FINISH,
		payload: {
			cannedMessages:cannedMessages.result
		}
	}
}

let getCannedCompanyMessagesFailure = () => {
	return {
		type: types.GET_COMPANY_CANNED_MESSAGES_FINISH,
		payload: {},
		error: true
	}
}

let getCannedAgentMessagesInitiated = () => {
	return {
		type: types.GET_AGENT_CANNED_MESSAGES,
		payload: {}
	}
}

let getCannedAgentMessagesFinished = (cannedMessages) => {
	return {
		type: types.GET_AGENT_CANNED_MESSAGES_FINISH,
		payload: {
			cannedMessages:cannedMessages.result
		}
	}
}

let getCannedAgentMessagesFailure = () => {
	return {
		type: types.GET_AGENT_CANNED_MESSAGES_FINISH,
		payload: {},
		error: true
	}
}

let createCannedAgentMessage = (message) => {
	return (dispatch, getState) => {
		let companyId = getState().app.currentAgent.userInfo.companyId

		dispatch(createCannedAgentMessageInitiated())

		api('/' + companyId + '/cannedMessagesByAgent')
			.post(message)
			.then(cannedMessage => dispatch(createCannedAgentMessageFinished(cannedMessage)))
			.catch(err => dispatch(createCannedAgentMessageFailure()))
	}
}

let createCannedAgentMessageInitiated = () => {
	return {
		type: types.CREATE_AGENT_CANNED_MESSAGE,
		payload: {}
	}
}

let createCannedAgentMessageFinished = (cannedMessage) => {
	return {
		type: types.CREATE_AGENT_CANNED_MESSAGE_FINISH,
		payload: {
			cannedMessage:cannedMessage.result
		}
	}
}

let createCannedAgentMessageFailure = () => {
	return {
		type: types.CREATE_AGENT_CANNED_MESSAGE_FINISH,
		payload: {},
		error: true
	}
}

let updateCannedAgentMessage = (message) => {
	return (dispatch, getState) => {
		let companyId = getState().app.currentAgent.userInfo.companyId

		dispatch(updateCannedAgentMessageInitiated())

		api('/' + companyId + '/cannedMessages/' + message.id)
			.put({message: message.message})
			.then(cannedMessage => dispatch(updateCannedAgentMessageFinished(cannedMessage)))
			.catch(err => dispatch(updateCannedAgentMessageFailure()))
	}
}

let updateCannedAgentMessageInitiated = () => {
	return {
		type: types.UPDATE_AGENT_CANNED_MESSAGE,
		payload: {}
	}
}

let updateCannedAgentMessageFinished = (cannedMessage) => {
	return {
		type: types.UPDATE_AGENT_CANNED_MESSAGE_FINISH,
		payload: {
			cannedMessage:cannedMessage.result
		}
	}
}

let updateCannedAgentMessageFailure = () => {
	return {
		type: types.UPDATE_AGENT_CANNED_MESSAGE_FINISH,
		payload: {},
		error: true
	}
}

let deleteCannedAgentMessage = (messageId) => {
	return (dispatch, getState) => {
		let companyId = getState().app.currentAgent.userInfo.companyId

		dispatch(deleteCannedAgentMessageInitiated())

		api('/' + companyId + '/cannedMessages/' + messageId)
			.delete()
			.then(cannedMessage => dispatch(deleteCannedAgentMessageFinished(cannedMessage)))
			.catch(err => dispatch(deleteCannedAgentMessageFailure()))
	}
}

let deleteCannedAgentMessageInitiated = () => {
	return {
		type: types.DELETE_AGENT_CANNED_MESSAGE,
		payload: {}
	}
}

let deleteCannedAgentMessageFinished = (cannedMessage) => {
	return {
		type: types.DELETE_AGENT_CANNED_MESSAGE_FINISH,
		payload: {
			cannedMessage:cannedMessage.result
		}
	}
}

let deleteCannedAgentMessageFailure = () => {
	return {
		type: types.DELETE_AGENT_CANNED_MESSAGE_FINISH,
		payload: {},
		error: true
	}
}

export default {getCannedMessages, createCannedAgentMessage, updateCannedAgentMessage, deleteCannedAgentMessage}
